<template lang="pug">
    .row.faqs-wrapper
        .col-12.col-sm-12.menu-mobile
            h1 Preguntas frecuentes
            h2.faqs-subtitle Ayuda e información sobre los registros, servicios y soporte.

            .row
                .col-12.col-sm-12
                    .category-box
                        h3 Categorías
                        ul
                            li(v-for="category in categories", v-bind:class="(selectedCategory && (category.id == selectedCategory.id)) ? 'active':''", @click="selectCategory(category)")
                              p {{category.name}}
        .col-12.col-sm-12.col-lg-9
            h1.desktop-only Preguntas frecuentes
            h2.faqs-subtitle.desktop-only Ayuda e información sobre los registros, servicios y soporte.
            hr.desktop-only
            .row(v-if="selectedCategory")
                .col-10.offset-1.col-sm-10.offset-sm-1.col-lg-12.offset-lg-0
                    h4 {{selectedCategory.name}}
                .col-10.offset-1.col-sm-10.offset-sm-1.col-lg-12.offset-lg-0.entry(v-for="(entry, index) in entries", :class="{even: index % 2, odd: !(index % 2)}")
                    FaqEntry(v-bind:entry="entry")
        .col-3.col-sm-3.col-lg-3.desktop-menu(v-if="categories.length")
            .category-box
                h3 Categorías
                ul
                    li(v-for="category in categories", v-bind:class="(selectedCategory && (category.id == selectedCategory.id)) ? 'active':''", @click="selectCategory(category)")
                      p {{category.name}}
</template>

<script>
import _ from 'underscore'
import Api from './services/Api'
import FaqEntry from '@/components/FaqEntry'
import S from 'string'

export default {
  name: 'Faqs',
  components: { FaqEntry },
  data() {
    return {
      categories: [],
      entries: [],
      selectedCategory: null,
    }
  },
  created() {
    const _this = this

    Api.getCategories('faqs')
      .then(response => {
        _this.categories = response.data.items
        if (_this.categories.length) _this.selectCategory(_this.categories[0])
      })
      .catch()
  },
  methods: {
    selectCategory(category) {
      const _this = this
      const token = this.$store.state.token

      Api.getEntriesByParent(category.id, token).then(response => {
        _this.entries = _.sortBy(response.data.items, item => {
          let title = S(item.title.rendered).trim().s
          // Extract the numbers of the string (if the numbers are not defined we return 0)
          if (!/^\d+.*/.test(title)) return 0

          let matches = /^(\d+).+/.exec(title)
          return parseInt(matches[1], 10)
        })
        _this.selectedCategory = category
        console.log(_this.entries[0])
      })
    },
  },
}
</script>

<style lang="scss">
@import './../variables';
.faqs-wrapper {
  margin: $gutter * 3 auto;
  max-width: 1140px;
  @import 'Faqs';
}
</style>



// WEBPACK FOOTER //
// src/components/Faqs.vue